var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "multiple-image-field"
  }, [_vm._l((_vm.imageCount), function(n) {
    return [_c('image-field', {
      attrs: {
        "model": _vm.model,
        "attribute": _vm.humanAttribute(n),
        "height": _vm.height,
        "value": _vm.values[n - 1]
      }
    }, [_vm._t("default")], 2)]
  }), _vm._v(" "), _c('p', {
    on: {
      "click": _vm.addImageField
    }
  }, [_c('i', {
    staticClass: "ss-icon"
  }, [_vm._v("plus")]), _vm._v(" New image")])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c6e6de3","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/multiple-image-field.vue
// module id = null
// module chunks = 